import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './EmptyInsights.module.scss';

export const EmptyInsights = () => {
  const { t } = useTranslation('insights');

  return (
    <div className={styles.container} data-testid="empty-insights">
      <div className={styles.wrapper}>
        <img
          className={styles.img}
          src="/app/static/images/empty-state/no-search-result.svg"
          alt=""
        />
        <h2 className={styles.title}>{t('insightsGroup.empty.title')}</h2>
        <p className={styles.description}>
          {t('insightsGroup.empty.description')}
        </p>
      </div>
    </div>
  );
};
